import * as React from "react";
import { forwardRef, memo } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOutlinedGlimmerIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "1rem",
	height: "1rem",
	viewBox: "0 0 19 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M8.85889 1.70801C9.02 1.27279 9.63528 1.27279 9.79639 1.70801L11.6704 6.77148C11.8223 7.18184 12.1458 7.50529 12.5562 7.65723L17.6196 9.53125C18.0548 9.69236 18.0548 10.3076 17.6196 10.4688L12.5562 12.3428C12.1458 12.4947 11.8223 12.8182 11.6704 13.2285L9.79639 18.292C9.63528 18.7272 9.02 18.7272 8.85889 18.292L6.98486 13.2285C6.83293 12.8182 6.50948 12.4947 6.09912 12.3428L1.03564 10.4688C0.60043 10.3076 0.60043 9.69236 1.03564 9.53125L6.09912 7.65723C6.50948 7.50529 6.83293 7.18184 6.98486 6.77148L8.85889 1.70801Z",
		stroke: "white"
	})]
});
const ForwardRef = forwardRef(SvgOutlinedGlimmerIcon);
const Memo = memo(ForwardRef);
export default Memo;
